/**
 * Zambian kwacha.
 */
export var ZMW = {
  code: 'ZMW',
  base: 10,
  exponent: 2
};